import { useEffect } from "../../__compat__/react/main.entry.mjs.mjs";
export const useOutsideClick = (refs, outsideClick) => {
    useEffect(() => {
        const handleOutsideClick = (event) => {
            const isOutsideClick = refs.every((ref) => ref.current && !ref.current.contains(event.target));
            if (isOutsideClick) {
                outsideClick();
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [outsideClick, refs]);
};
//# sourceMappingURL=useOutsideClick.mjs.mjs.map